import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#f98300',
        secondary: '#044690',
        accent: '#8c9eff',
        error: '#b71c1c'
      }
    }
  }
})
